module.exports = __webpack_public_path__ + "static/img/Permiso(2).2e57ee0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/Permiso(2).jpg
// module id = VTJ3
// module chunks = 0